import React from 'react';
import Dropzone from 'react-dropzone';
import HtmlToReactParser from 'html-to-react';
import Alert from '../notification/Alert';
import Icon from '../../assets/icons/Icon';

const htmlToReactParser = new HtmlToReactParser.Parser();

const CustomDropZone = (props) => {
    const {
        input: { onChange, name, value },
        customHeight,
        label,
        meta: { touched, error },
        fileChangedHandler,
        'data-cy': dataCy,
    } = props;

    const onDrop = (file) => {
        onChange(
            file.map((fl) =>
                Object.assign(fl, {
                    preview: URL.createObjectURL(fl),
                })
            )
        );
        fileChangedHandler(
            file.map((fl) =>
                Object.assign(fl, {
                    preview: URL.createObjectURL(fl),
                })
            )
        );
    };

    const removeFile = (index, e) => {
        e.preventDefault();
        onChange(value.filter((val, i) => i !== index));
        fileChangedHandler(value.filter((val, i) => i !== index));
    };

    return (
        <>
            {touched && error && (
                <Alert color="danger" className="alert--colored" icon>
                    <p data-cy={`${dataCy}--error`}>
                        {htmlToReactParser.parse(error)}
                    </p>
                </Alert>
            )}
            <div
                className={`dropzone dropzone--single${
                    customHeight ? ' dropzone--custom-height' : ''
                }`}
            >
                <Dropzone
                    accept= {{'image/*': ['.jpeg', '.png']}}
                    name={name}
                    multiple={false}
                    onDrop={(fileToUpload) => onDrop(fileToUpload)}
                >
                    {({ getRootProps, getInputProps }) => (
                        <div {...getRootProps()} className="dropzone__input">
                            {(!value || value.length === 0) && (
                                <div className="dropzone__drop-here">
                                    <Icon icon="Upload" width="16" inline />{' '}
                                    {label}
                                </div>
                            )}
                            <input {...getInputProps()} />
                        </div>
                    )}
                </Dropzone>
                {value && Array.isArray(value) && value.length > 0 && (
                    <aside className="dropzone__img">
                        <img src={value[0].preview} alt="drop-img" />
                        <p className="dropzone__img-name">{value[0].name}</p>
                        <button
                            className="dropzone__img-delete"
                            type="button"
                            onClick={(e) => removeFile(0, e)}
                            data-cy={`${dataCy}--removeBtn`}
                        >
                            Remove
                        </button>
                    </aside>
                )}
            </div>
        </>
    );
};

CustomDropZone.defaultProps = {
    customHeight: false,
    label: '',
    'data-cy': undefined,
};

export default CustomDropZone;
